import I18n from 'I18n';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Media } from 'foundations-components/transitional/components/Media';
import { MediaBody } from 'foundations-components/transitional/components/MediaBody';
import { MediaRight } from 'foundations-components/transitional/components/MediaRight';
import { Link } from 'foundations-components/transitional/components/Link';
import { TileSection } from 'foundations-components/transitional/components/Tile';
import _difference from 'hs-lodash/difference';
import _get from 'hs-lodash/get';
import { useContext } from 'react';
import { OBJECT_TYPE_TO_CARD_DEFAULT_PROPERTIES } from '../../constants/associations';
import { objectTypes, pluralTypeToSingle } from '../../constants/types';
import { AppContext } from '../../contexts/app/context';
import { AssociationsPropsContext } from '../../contexts/associations/PropsContext';
import Avatar from '../common/Avatar';
import FormattedCardProperty from '../common/FormattedCardProperty/FormattedCardProperty';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CrmObjectCard({
  item,
  type,
  onPreviewClick,
  propertiesDetails,
  propertyKeysToShow
}) {
  const {
    apiWrapper,
    portalId
  } = useContext(AssociationsPropsContext);
  const {
    appName
  } = useContext(AppContext);
  const objectLabel = OBJECT_TYPE_TO_CARD_DEFAULT_PROPERTIES[type].reduce((result, el) => /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
  result.concat(`${item.properties[el] || ''} `), '');
  const propertiesToShow = _difference(propertyKeysToShow, OBJECT_TYPE_TO_CARD_DEFAULT_PROPERTIES[type]);
  const getPropertyValue = key => {
    if (key === 'amount' && _get(item, 'properties.deal_currency_code') && _get(item, `properties.${key}`, '')) {
      return `${I18n.currencySymbols[_get(item, 'properties.deal_currency_code')].symbol}${_get(item, `properties.${key}`, '')}`;
    }
    return _get(item, `properties.${key}`, '');
  };
  const getAvatarProperties = () => {
    if (type === objectTypes.contacts) {
      return {
        vid: Number(item.id),
        email: item.properties.email
      };
    }
    if (type === objectTypes.companies) {
      return {
        companyId: Number(item.id),
        domain: item.properties.domain,
        fileManagerKey: item.properties.hs_avatar_filemanager_key
      };
    }
    return {};
  };
  return /*#__PURE__*/_jsxs(TileSection, {
    "data-test-id": `${appName}-${pluralTypeToSingle[type]}-card`,
    children: [/*#__PURE__*/_jsxs(Media, {
      children: [/*#__PURE__*/_jsx(MediaBody, {
        children: /*#__PURE__*/_jsx(Link, {
          "data-test-id": `${appName}-${pluralTypeToSingle[type]}-card-name`,
          truncate: true,
          onClick: () => onPreviewClick(item, type),
          children: objectLabel.trim() || '--'
        })
      }), /*#__PURE__*/_jsx(MediaRight, {
        children: Object.keys(objectTypes).filter(key => key !== objectTypes.meetings).includes(type) ? /*#__PURE__*/_jsx(Avatar, Object.assign({
          portalId: portalId,
          type: pluralTypeToSingle[type],
          size: "xs",
          getAvatarsApi: apiWrapper.getAvatars
        }, getAvatarProperties())) : null
      })]
    }), /*#__PURE__*/_jsx(TFlex, {
      direction: "column",
      children: propertiesToShow.map(key => /*#__PURE__*/_jsx(FormattedCardProperty, {
        propertyKey: key,
        value: getPropertyValue(key) || '--',
        propertyDetails: propertiesDetails[key],
        entityType: pluralTypeToSingle[type],
        appName: appName
      }, key))
    })]
  });
}
export default CrmObjectCard;